<section [ngClass]="{'fixed-header': fixedHeader}">
  <app-header></app-header>
  <app-main></app-main>
</section>

